import React, { useEffect, useState } from "react";
import Modal from "../ui/Modal";
import { BACKEND } from "../../config/configEnvs";
import axios from "axios";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import AnuncioComentario from "../inicio/AnuncioComentario";
import { FaChevronLeft, FaChevronRight, FaUserCircle } from "react-icons/fa";

import Moment from "react-moment";
import "moment/locale/es";
const ComentariosAnunciosModal = ({ active, anuncio, setModal }) => {
  const [comentarios, setComentarios] = useState([]);
  const [totalDocs, setTotalDocs] = useState(0);
  const [serviciosMetaData, setServiciosMetaData] = useState({
    totalPages: 0,
    page: 0,
    hasPrevPage: false,
    hasNextPage: false,
  });
  const [page, setPage] = useState(1);
  const [comentarioFormValues, setComentariosFormvalues] = useState({
    content: "",
  });

  const user = useSelector((state) => state.auth.user);

  const getComents = async () => {
    if (anuncio) {
      const responses = await axios.get(
        `${BACKEND}/api/anunciosComentarios?where[anuncio][equals]=${anuncio.id}&page=${page}&limit=15`
      );
      setComentarios(responses.data.docs);
      setTotalDocs(responses.data.totalDocs);
      setServiciosMetaData({
        totalPages: responses.data.totalPages,
        page: responses.data.page,
        hasNextPage: responses.data.hasNextPage,
        hasPrevPage: responses.data.hasPrevPage,
      });
    }
  };

  const postComment = async (event) => {
    event.preventDefault();
    if (comentarioFormValues.content === "") {
      return;
    }
    const responses = await axios.post(`${BACKEND}/api/anunciosComentarios`, {
      anuncio: anuncio.id,
      autor: user.id,
      content: comentarioFormValues.content,
    });
    toast.success("Publicado ");
    setComentariosFormvalues({ content: "" });
    setComentarios([...comentarios, responses.data.doc]);
  };

  useEffect(() => {
    getComents();
  }, [page, anuncio]);

  useEffect(() => {
    setPage(1);
  }, [anuncio]);

  const pageRange = [];
  const startPage = Math.max(1, page - 2);
  const endPage = Math.min(
    page + 2,
    serviciosMetaData.totalPages ? serviciosMetaData.totalPages : 5
  );
  for (let i = startPage; i <= endPage; i++) {
    pageRange.push(i);
  }
  return (
    <Modal
      onClose={() => setModal({ active: false, anuncio: null })}
      activeModal={active}
      title="Anuncio"
    >
      {anuncio && (
        <div className=" pb-6">
          <div className="flex items-center py-4 space-x-4">
            {anuncio?.autor?.foto ? <img
              width={200}
              height={200}
              className="w-9 h-9 rounded-full"
              src={anuncio?.autor?.foto?.url}
              alt={anuncio?.autor?.name}
            /> : <FaUserCircle className=" w-9 h-9"/>}
            <div className="grid grid-rows-2">
              <span className="font-medium  text-gray-800">
                {anuncio?.autor?.name}
              </span>
              <span className="text-xs text-zinc-600">
                <Moment className=" capitalize   not-italic" fromNow>
                  {anuncio?.createdAt}
                </Moment>{" "}
              </span>
            </div>
          </div>
          <div className=" font-medium text-gray-900 pb-4">
            <span>{anuncio?.title}</span>
          </div>

          {anuncio?.imagen && (
            <div className="pb-4">
              <img
                width={800}
                height={800}
                className=" w-full mx-auto   h-auto object-contain "
                src={anuncio?.imagen?.url}
                alt={"Post"}
              />
            </div>
          )}

          <div>
            <p className="text-xs text-slate-600 whitespace-pre-line">
              {anuncio.descripcion}
            </p>
          </div>
        </div>
      )}
      <div className=" relative">
        {comentarios.map((comentario) => (
          <AnuncioComentario comentario={comentario} key={comentario.id} />
        ))}

        {comentarios && comentarios?.length > 0 && (
          <div className="flex flex-col items-center py-10">
            <span className="text-sm text-gray-700 dark:text-gray-500 ">
              Mostrando
              <span className="font-semibold text-gray-900  ">
                {" "}
                {comentarios.length}
              </span>{" "}
              de
              <span className="font-semibold text-gray-900  ">
                {" "}
                {totalDocs}
              </span>{" "}
              comentarios
            </span>

            <nav aria-label="Page navigation example">
              <ul className="flex items-center -space-x-px h-10 text-base">
                <li>
                  <button
                    onClick={() => setPage(page - 1)}
                    disabled={page === 1}
                    className="flex items-center justify-center px-4 h-10 ml-0 leading-tight text-gray-500 bg-white border border-gray-300 rounded-l-lg hover:bg-gray-100 hover:text-gray-700 "
                  >
                    <span className="sr-only">Previous</span>
                    <FaChevronLeft className=" w-3 h-3 text-gray-700 dark:text-gray-400" />
                  </button>
                </li>

                {pageRange.map((pageNumber) => (
                  <li key={pageNumber}>
                    <button
                      onClick={() => setPage(pageNumber)}
                      className={`flex items-center justify-center px-4 h-10 leading-tight ${
                        page === pageNumber
                          ? "text-white  border-orange-300 bg-orange-500 hover:bg-orange-600  "
                          : "text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 "
                      }`}
                    >
                      {pageNumber}
                    </button>
                  </li>
                ))}

                <li>
                  <button
                    onClick={() => setPage(page + 1)}
                    disabled={!serviciosMetaData.hasNextPage}
                    className="flex items-center justify-center px-4 h-10 leading-tight text-gray-500 bg-white border border-gray-300 rounded-r-lg hover:bg-gray-100 hover:text-gray-700 "
                  >
                    <span className="sr-only">Next</span>
                    <FaChevronRight className=" w-3 h-3 text-gray-700 dark:text-gray-400" />
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        )}

        <div className=" sticky bottom-0">
          <form onSubmit={postComment} className="">
            <div className="py-2 px-4  bg-white rounded-lg rounded-t-lg border border-gray-200 ">
              <label for="comment" className="sr-only">
                Tu comentario
              </label>
              <textarea
                id="comment"
                rows="2"
                value={comentarioFormValues.content}
                onChange={(e) =>
                  setComentariosFormvalues((prev) => ({
                    ...prev,
                    content: e.target.value,
                  }))
                }
                className="px-0 w-full text-sm text-gray-900 border-0 focus:ring-0 focus:outline-none "
                placeholder="Escribe un comentario"
                required
              ></textarea>
            </div>
            <button
              type="submit"
              className="inline-flex items-center mt-4 py-2.5 px-4 text-xs font-medium text-center text-white bg-[#F64] rounded-lg focus:ring-4 focus:ring-primary-200 0"
            >
              Publicar
            </button>
          </form>
        </div>
      </div>
    </Modal>
  );
};

export default ComentariosAnunciosModal;
